import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, inject } from "@angular/core";
import { AbstractControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatButton } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { MatProgressBar } from "@angular/material/progress-bar";
import { LayoutAlignDirective } from "@ngbracket/ngx-layout/flex";
import { CommonDialogsService } from "@tylertech/common-dialogs-module";
import { LgdFormControlFactory, LgdTextComponent } from "@tylertech/lgd-reactive-forms";
import { UBDashboardService } from "../../services";

export interface ServiceRequestRejectDialogData
{
    readonly requestId: string;
}

@Component({
    selector: "service-request-reject-dialog",
    templateUrl: "./serviceRequestRejectDialog.tmpl.html",
    imports: [
        CdkScrollable,
        LayoutAlignDirective,
        LgdTextComponent,
        MatButton,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle,
        MatProgressBar,
        ReactiveFormsModule,
    ]
})
export class ServiceRequestRejectDialogComponent
{
    private readonly dialogRef = inject<MatDialogRef<ServiceRequestRejectDialogComponent, boolean>>(MatDialogRef);
    private readonly data = inject<ServiceRequestRejectDialogData>(MAT_DIALOG_DATA);
    private commonDialogsService = inject(CommonDialogsService);
    private $ubDashboardService = inject(UBDashboardService);

    readonly formGroup: FormGroup;
    isSaving: boolean;

    constructor()
    {
        this.formGroup = new FormGroup({
            reason: LgdFormControlFactory.text(undefined, true, { maxLength: 100 }),
        });
    }

    private get reasonControl(): AbstractControl<string> { return this.formGroup.get("reason"); }
    private get requestId(): string { return this.data.requestId; }

    save(): void
    {
        this.isSaving = true;
        this.$ubDashboardService.rejectServiceRequest(
            {
                Id: this.requestId,
                Value: this.reasonControl.value,
            })
            .then(
                (result: boolean) =>
                {
                    if (result)
                    {
                        this.dialogRef.close(true);
                    }
                    else
                    {
                        // TODO - We are already in a dialog context... DO NOT OPEN SECONDARY DIALOGS
                        this.commonDialogsService.showAlertMessage("Save failed");
                    }
                },
                () =>
                {
                    // TODO - We are already in a dialog context... DO NOT OPEN SECONDARY DIALOGS
                    this.commonDialogsService.showAlertMessage("Save failed");
                })
            .finally(() =>
            {
                this.isSaving = false;
            });
    }
}
